import React from 'react';
import classNames from 'classnames';

import './SalesTv/SalesTv.scss';

const SlideIndicator = (props) => {

    if (!props.showIndicator) {
        return null;
    }
    const onlyActiveSlides = props.slides.filter(slide => slide.inactive !== 1 &&
        slide.tvIndex === props.tvIndex);

    const percentageWidth = (1 / onlyActiveSlides.length) * 100;
    const style = { width: `calc(${percentageWidth}% - 1px)` };

    const slideControl = onlyActiveSlides.map((slide) => {
        const indicatorClasses = classNames({
            indicator: true,
            active: props.currentSlideId === slide.id,
        });

        return (
            <li
                key={slide.id}
                onClick={() => props.goToSlide(slide.id)}
                className={indicatorClasses}
                style={style}
            />
        );
    });

    return <ul className="indicator-holder">{slideControl}</ul>;
};

SlideIndicator.propTypes = {
    slides: React.PropTypes.array.isRequired,
    goToSlide: React.PropTypes.func.isRequired,
};

export default SlideIndicator;



/** WEBPACK FOOTER **
 ** ./client/components/SlideIndicator.jsx
 **/